export default function Process() {

	let triggers = document.querySelectorAll('.js-process-open');

	triggers.forEach(trigger => {
		trigger.addEventListener('click', () => {
			let name = trigger.getAttribute('data-name');

			document.querySelector('.c-process').classList.add('active');
			document.querySelectorAll('.c-process__item').forEach(item => {
				item.classList.remove('active');
			});

			document.querySelector(`.c-process__item[data-name="${name}"]`).classList.add('active');
		})
	})
	let close = document.querySelectorAll('.js-process-close');

	close.forEach(trigger => {
		trigger.addEventListener('click', () => {
			document.querySelector('.c-process').classList.remove('active');
			document.querySelectorAll('.c-process__item').forEach(item => {
				item.classList.remove('active');
			});
		});
	});

}
